import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import SellingService from "../services/SellingService";
import getCurrentUserId from "../reduxSaga/sagas/requests/currentUserId";
import toastr from "toastr";
const DateTimeModal = ({ modalVisible, setModalVisible, creationDate, reference, handleDateChange, handleReferenceChange, row , setChange , change }) => {

    const [selectedDate, setSelectedDate] = useState(new Date(creationDate).toISOString().slice(0, 16)); // Format for datetime-local
    const [selectedReference, setSelectedReference] = useState(reference);

    useEffect(() => {
        console.log(reference)
        console.log(creationDate)
        console.log("row", row)
        setSelectedReference(reference)
        setSelectedDate(new Date(creationDate).toISOString().slice(0, 16))

    }, [reference, creationDate, row])
    const handleModalClose = () => setModalVisible(false);
    const handleModalOpen = () => setModalVisible(true);

    const handleDateChangeInternal = (e) => {
        setSelectedDate(e.target.value);
    };

    const handleReferenceChangeInternal = (e) => {
        setSelectedReference(e.target.value);
    };

    const handleSave = () => {
        // Create the model object to send to the service
        const model = {
            date: selectedDate + ":00",
            idBonDeCommandeSale: sessionStorage.getItem("DocumentId"),
            idUser: getCurrentUserId(),
            ref: selectedReference,
            uniqueId: row.uniqueId,
        };

        // Call the service to update the command
        SellingService.updateBC(model)
            .then((response) => {
                toastr.success("Le bon de commande a été mis à jour avec succès.");
                handleModalClose()
                // setChange(!change)
                window.location.reload();
            })
            .catch((error) => {
                console.error("Erreur lors de la mise à jour :", error);
                toastr.error("Une erreur s'est produite lors de la mise à jour du bon de commande.");
                handleModalClose()
            })
    };

    return (
        <div>
            {/* Date and Time Modal */}
            <Modal show={modalVisible} onHide={handleModalClose} centered>
                <Modal.Header>
                    <Modal.Title>Modifier Date et Référence</Modal.Title>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={handleModalClose}
                        style={{ fontSize: "1.5rem", background: "none", border: "none" }}
                    >
                        ×
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formBasicDateTime">
                            <Form.Label>Date</Form.Label>
                            {/* Date and Time Input */}
                            <input
                                type="datetime-local"
                                value={selectedDate}
                                onChange={handleDateChangeInternal}
                                className="form-control"
                                required
                            />
                        </Form.Group>

                        <Form.Group controlId="formBasicReference">
                            <Form.Label>Référence </Form.Label>
                            {/* Reference Number Input */}
                            <input
                                type="text"
                                value={selectedReference}
                                onChange={handleReferenceChangeInternal}
                                className="form-control"
                                placeholder="Entrez la référence"
                                required
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleSave}>
                        Enregistrer
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default DateTimeModal;
